<template>
    <div>
        <div class="full_video" v-show="home_video">
            <div class="center">
                <div class="icon icon_close" title="关闭" @click="show_home_video('0')"></div>
                <video class="video-js" controls preload="auto" :src="mp4Url" style="width:100%;height:100%;" :poster="cover" :muted="muteStatus" :autoplay="playStatus"></video>
                <!--<video src="http://www.corner.com.cn/video/corner_main.mp4" width="100%" height="100%" controls autoplay ref="vueMiniPlayer"></video>-->
            </div>
        </div>

        <div class="banner">
            <div id="slideBox" class="slideBox">
                <div class="hd">
                    <ul>
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                    </ul>
                </div>
                <div class="bd">
                    <ul>
                        <li><a :href="banner1_url"><img :src="banner1_pic" /></a></li>
                        <li><a :href="banner2_url"><img :src="banner2_pic" /></a></li>
                        <li><a :href="banner3_url"><img :src="banner3_pic" /></a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="center">
                <h1>解决方案<span><a href="javascript:void(0);" @click.stop="goTo('ZhiHuiGongShui')">查看更多解决方案<i class="icon icon_more"></i></a></span></h1>
                <div class="album" @click.stop="HomeJieJueFangAn_view(H_JieJueFangAn_1.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+H_JieJueFangAn_1.solutionImg" :onerror="defaultImg" /></span>
                        <span class="title" :title="H_JieJueFangAn_1.solutionTitle"><span>{{ H_JieJueFangAn_1.solutionTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="H_JieJueFangAn_1.solutionDescription"></span>
                    </div>
                </div>
                <div class="album" @click.stop="HomeJieJueFangAn_view(H_JieJueFangAn_2.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+H_JieJueFangAn_2.solutionImg" :onerror="defaultImg" /></span>
                        <span class="title" :title="H_JieJueFangAn_2.solutionTitle"><span>{{ H_JieJueFangAn_2.solutionTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="H_JieJueFangAn_2.solutionDescription"></span>
                    </div>
                </div>
                <div class="album" @click.stop="HomeJieJueFangAn_view(H_JieJueFangAn_3.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+H_JieJueFangAn_3.solutionImg" :onerror="defaultImg" /></span>
                        <span class="title" :title="H_JieJueFangAn_3.solutionTitle"><span>{{ H_JieJueFangAn_3.solutionTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="H_JieJueFangAn_3.solutionDescription"></span>
                    </div>
                </div>
                <!-- <h1>解决方案<span><a href="javascript:void(0);" @click.stop="goTo('ZhiHuiGongShui')">查看更多解决方案<i class="icon icon_more"></i></a></span></h1>
                <div class="album" v-for="(JieJueFangAn, index) in JieJueFangAn_List" :key="index" :id="JieJueFangAn.id" @click.stop="HomeJieJueFangAn_view(JieJueFangAn.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+JieJueFangAn.solutionImg" :onerror="defaultImg" /></span>
                        <span class="title" :title="JieJueFangAn.solutionTitle"><span>{{ JieJueFangAn.solutionTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="JieJueFangAn.solutionDescription"></span>
                    </div>
                </div> -->
            </div>
        </div>
        <!-- <div class="block block_style1">
            <div class="center">
                <h1>媒体看凯纳<span><a href="javascript:void(0);" @click.stop="goTo('MeiTiKanKaiNa')">查看更多新闻资讯<i class="icon icon_more"></i></a></span></h1>
                <div class="album" v-for="(MeiTiKanKaiNa, index) in MeiTiKanKaiNa_List" :key="index" :id="MeiTiKanKaiNa.id" @click.stop="HomeMeiTiKanKaiNa_view(MeiTiKanKaiNa.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+MeiTiKanKaiNa.newsUrl" :onerror="defaultImg" /></span>
                        <span class="title" :title="MeiTiKanKaiNa.newsTitle"><span>{{ MeiTiKanKaiNa.newsTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="MeiTiKanKaiNa.newsDescription"></span>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="block block_style1">
            <div class="center">
                <h1>企业动态<span><a href="javascript:void(0);" @click.stop="goTo('QiYeDongTai')">查看更多新闻资讯<i class="icon icon_more"></i></a></span></h1>
                <div class="album" v-for="(QiYeDongTai, index) in QiYeDongTai_List" :key="index" :id="QiYeDongTai.id" @click.stop="HomeQiYeDongTai_view(QiYeDongTai.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+QiYeDongTai.newsUrl" :onerror="defaultImg" /></span>
                        <span class="title" :title="QiYeDongTai.newsTitle"><span>{{ QiYeDongTai.newsTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="QiYeDongTai.newsDescription"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="block block_style2">
            <div class="center">
                <h1>典型案例<span><a href="javascript:void(0);" @click.stop="goTo('ChengGongAnLi')">查看更多典型案例<i class="icon icon_more"></i></a></span></h1>
                <div class="album" @click.stop="HomeChengGongAnLi_view(ChengGongAnLi_List_1.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+ChengGongAnLi_List_1.webIco" :onerror="defaultImg" /></span>
                        <span class="title" :title="ChengGongAnLi_List_1.webTitle"><span>{{ ChengGongAnLi_List_1.webTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="ChengGongAnLi_List_1.webName"></span>
                    </div>
                </div>
                <div class="album" @click.stop="HomeChengGongAnLi_view(ChengGongAnLi_List_2.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+ChengGongAnLi_List_2.webIco" :onerror="defaultImg" /></span>
                        <span class="title" :title="ChengGongAnLi_List_2.webTitle"><span>{{ ChengGongAnLi_List_2.webTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="ChengGongAnLi_List_2.webName"></span>
                    </div>
                </div>
                <div class="album" @click.stop="HomeChengGongAnLi_view(ChengGongAnLi_List_3.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+ChengGongAnLi_List_3.webIco" :onerror="defaultImg" /></span>
                        <span class="title" :title="ChengGongAnLi_List_3.webTitle"><span>{{ ChengGongAnLi_List_3.webTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="ChengGongAnLi_List_3.webName"></span>
                    </div>
                </div>
                <div class="album" @click.stop="HomeChengGongAnLi_view(ChengGongAnLi_List_4.id)">
                    <div class="div">
                        <span class="pic"><img :src="img_address+ChengGongAnLi_List_4.webIco" :onerror="defaultImg" /></span>
                        <span class="title" :title="ChengGongAnLi_List_4.webTitle"><span>{{ ChengGongAnLi_List_4.webTitle }}</span><i class="icon icon_more"></i></span>
                        <span class="text" v-html="ChengGongAnLi_List_4.webName"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="block block_style3">
            <div class="video">
                <span @click="show_home_video('1')"><img src="../assets/img/video_3.png" /></span>
            </div>
        </div>
    </div>
</template>

<script>
import {
    HomeSlideBox,
    HomeJieJueFangAn,
    HomeMeiTiKanKaiNa,
    HomeQiYeDongTai,
    HomeChengGongAnLi_1,
    HomeChengGongAnLi_2,
    HomeChengGongAnLi_3,
    HomeChengGongAnLi_4,
} from "../request/api"; // 导入接口

import Video from "video.js";
import "video.js/dist/video-js.css";

import "../assets/js/jquery.SuperSlide.2.1.3.js";
export default {
    name: "Home",
    data() {
        return {
            title: "Home",
            sub_title: "",
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            home_video: false,
            cover: "", // 封面
            muteStatus: false, // 是否静音自动播放
            playStatus: false, //是否自动播放
            mp4Url: "",

            img_address: "http://www.corner.com.cn",
            defaultImg:
                'this.src="' + require("../assets/img/default.jpg") + '"',

            //banner1_pic: require('@/assets/img/default.jpg'),
            banner1_pic: "",
            banner1_url: "",

            banner2_pic: "",
            banner2_url: "",

            banner3_pic: "",
            banner3_url: "",

            SlideBox_List: [],
            JieJueFangAn_List: [],
            MeiTiKanKaiNa_List: [],
            QiYeDongTai_List: [],
            ChengGongAnLi_List: [],

            ChengGongAnLi_List_1: {
                id: "",
                webTitle: "",
                webBasehost: "",
                webIco: "",
                webName: "",
            },
            ChengGongAnLi_List_2: {
                id: "",
                webTitle: "",
                webBasehost: "",
                webIco: "",
                webName: "",
            },
            ChengGongAnLi_List_3: {
                id: "",
                webTitle: "",
                webBasehost: "",
                webIco: "",
                webName: "",
            },
            ChengGongAnLi_List_4: {
                id: "",
                webTitle: "",
                webBasehost: "",
                webIco: "",
                webName: "",
            },

            H_JieJueFangAn_1: [], //首页解决方案1
            H_JieJueFangAn_2: [], //首页解决方案2
            H_JieJueFangAn_3: [], //首页解决方案3
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        this.HomeSlideBox_data();
        //this.HomeJieJueFangAn_data();
        this.HomeMeiTiKanKaiNa_data();
        this.HomeQiYeDongTai_data();
        this.HomeChengGongAnLi_data();

        HomeJieJueFangAn({
            pageNum: 1, //当前是第几页
            pageSize: 300, //每页显示多少条
        }).then((res) => {
            //console.log( res );
        });

        this.HomeJieJueFangAn_1_data(6); //首页解决方案1
        this.HomeJieJueFangAn_2_data(8); //首页解决方案2
        this.HomeJieJueFangAn_3_data(9); //首页解决方案3
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
        jQuery(".slideBox").slide({ mainCell: ".bd ul", autoPlay: true });
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        show_home_video(e) {
            if (e == 1) {
                this.home_video = true;
                this.playStatus = true;
                this.muteStatus = false;
                //this.mp4Url = 'http://www.corner.com.cn/video/corner_main.mp4';
                this.mp4Url =
                    "http://www.corner.com.cn/video/corner_new_2024.mp4";
            } else {
                this.home_video = false;
                this.playStatus = false;
                this.muteStatus = false;
                this.mp4Url = "";
            }
        },
        HomeSlideBox_data() {
            //首页轮播图
            HomeSlideBox({
                pageNum: 1, //当前是第几页
                pageSize: 3, //每页显示多少条
            }).then((res) => {
                this.banner1_pic = this.img_address + res.rows[0].webIco; //图片路径
                this.banner1_url = res.rows[0].webBasehost; //点击跳转路径

                this.banner2_pic = this.img_address + res.rows[1].webIco;
                this.banner2_url = res.rows[1].webBasehost;

                this.banner3_pic = this.img_address + res.rows[2].webIco;
                this.banner3_url = res.rows[2].webBasehost;
            });
        },
        // HomeJieJueFangAn_data(){ //首页解决方案
        //     HomeJieJueFangAn({
        //         pageNum : 1, //当前是第几页
        //         pageSize : 3, //每页显示多少条
        //     }).then((res) => {
        //         this.JieJueFangAn_List = res.rows;
        //     });
        // },
        HomeJieJueFangAn_1_data(id) {
            //首页解决方案1
            HomeJieJueFangAn({
                id: id,
            }).then((res) => {
                this.H_JieJueFangAn_1 = res.rows[0];
            });
        },
        HomeJieJueFangAn_2_data(id) {
            //首页解决方案2
            HomeJieJueFangAn({
                id: id,
            }).then((res) => {
                this.H_JieJueFangAn_2 = res.rows[0];
            });
        },
        HomeJieJueFangAn_3_data(id) {
            //首页解决方案3
            HomeJieJueFangAn({
                id: id,
            }).then((res) => {
                this.H_JieJueFangAn_3 = res.rows[0];
            });
        },
        HomeJieJueFangAn_view(id) {
            //带uuid跳转详情页面
            this.$router.push({
                path: "JieJueFangAnView",
                query: { id: id },
            });
        },
        HomeMeiTiKanKaiNa_data() {
            //首页媒体看凯纳
            HomeMeiTiKanKaiNa({
                pageNum: 1, //当前是第几页
                pageSize: 3, //每页显示多少条
            }).then((res) => {
                //console.log( "媒体看凯纳：",res );
                this.MeiTiKanKaiNa_List = res.rows;
            });
        },
        HomeMeiTiKanKaiNa_view(id) {
            //带uuid跳转详情页面
            this.$router.push({
                path: "XiWenView",
                //query: { id: id, newsType: 201 },
                query: {
                    id: id,
                    newsType: 201,
                    url: "QiYeDongTai",
                    title: "媒体看凯纳",
                },
            });
        },
        HomeQiYeDongTai_data() {
            //首页媒体看凯纳
            HomeQiYeDongTai({
                pageNum: 1, //当前是第几页
                pageSize: 3, //每页显示多少条
            }).then((res) => {
                //console.log( "企业动态：",res );
                this.QiYeDongTai_List = res.rows;
            });
        },
        HomeQiYeDongTai_view(id) {
            //带uuid跳转详情页面
            this.$router.push({
                path: "XiWenView",
                //query: { id: id, newsType: 203 },
                query: {
                    id: id,
                    newsType: 203,
                    url: "QiYeDongTai",
                    title: "企业动态",
                },
            });
        },
        HomeChengGongAnLi_data() {
            //首页典型案例
            HomeChengGongAnLi_1({
                pageNum: 1, //当前是第几页
                pageSize: 4, //每页显示多少条
            }).then((res) => {
                this.ChengGongAnLi_List_1 = res.rows[0];
            });
            HomeChengGongAnLi_2({
                pageNum: 1, //当前是第几页
                pageSize: 4, //每页显示多少条
            }).then((res) => {
                this.ChengGongAnLi_List_2 = res.rows[0];
            });
            HomeChengGongAnLi_3({
                pageNum: 1, //当前是第几页
                pageSize: 4, //每页显示多少条
            }).then((res) => {
                this.ChengGongAnLi_List_3 = res.rows[0];
            });
            HomeChengGongAnLi_4({
                pageNum: 1, //当前是第几页
                pageSize: 4, //每页显示多少条
            }).then((res) => {
                this.ChengGongAnLi_List_4 = res.rows[0];
            });
        },
        HomeChengGongAnLi_view(id) {
            //带uuid跳转详情页面
            this.$router.push({
                path: "ArticleView",
                query: { id: id, webType: 104 },
            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue